export default "__VITE_ASSET__a43a9611__"